<template>
    <section :id="component.identifier ? component.identifier : ''" v-if="show" class="mb-64">

        <div class="site__container pt-64 overflow-hidden">

            <div v-if="!hasContent" :class="[text1Width]" class="mx-auto text-center px-24">
                <h1 v-if="hasTitle"
                    :class="titleSize"
                    class="mb-32 leading-normal site__font--display font-semibold whitespace-pre-line"
                >
                    {{ translated(component.heading) }}
                </h1>
<!--                <div
                    :class="textSize"
                    v-html="translated(component.content)"
                ></div>-->
            </div>

            <div
                v-else
                :class="[ horizontalStyle, hasTitle ? text2Alignment : 'text-center']"
                class="mx-auto px-24 lg:px-0"
            >
                <h1
                    v-if="hasTitle"
                    :class="[text2AWidth, text2AMargin, titleSize]" class="break-words flex-none mx-auto mb-32 site__font--display font-semibold whitespace-pre-line"
                >{{ translated(component.heading) }}</h1>
                <section
                    :class="textSize"
                    :data-version="version"
                    class="flex-grow wysiwyg-content min-w-0"
                    v-html="translated(component.content)"
                >
                </section>
            </div>

        </div>
    </section>
</template>

<script>
import {mapState} from 'pinia';
import { useCommonStore } from '../../state/common';
import { useBrandingStore } from '../../state/branding';
import {responsive, runningInBrowser} from '../../helpers';

export default {
    props: {
        component: {
            required: true,
        },
    },
    data: function () {
        return {
            style: 'horizontal',
        };
    },
    computed: {
        ...mapState(useCommonStore, ['locale']),
        ...mapState(useBrandingStore, ['preview']),
        version() {
            return runningInBrowser() ? 'preview-' + this.preview.type : 'live';
        },
        show() {
            return runningInBrowser() || this.hasContent || this.hasTitle;
        },
        hasContent() {
            return !!this.translated(this.component.content).replace(/<[^>]+>/g, '').length;
        },
        titleSize() {
            return responsive(this.preview.type, 'text-heading-1 md:text-heading-1 lg:text-big');
        },
        textSize() {
            return responsive(this.preview.type, 'text-body md:text-body');
        },
        hasTitle() {
            return this.translated(this.component.heading) && this.translated(this.component.heading).length;
        },
        text1Width() {
            return responsive(this.preview.type, 'w-full md:w-3/4 lg:w-2/3');
        },
        text2AWidth() {
            return responsive(this.preview.type, 'w-full md:w-1/3 lg:w-1/3');
        },
        text2AMargin() {
            return responsive(this.preview.type, 'md:mr-32 lg:mr-48');
        },
        text2Alignment() {
            return responsive(this.preview.type, 'text-center md:text-left');
        },
        horizontalStyle() {
            return responsive(this.preview.type, 'block md:flex');
        },
    },
    mounted() {
        this.$emit('loaded');
    },
};
</script>

<style scoped>

</style>
